import axios from 'axios';
import * as ff from '../constants/FormFields';
import get from 'lodash/get';
import { getFormatedExpDate, getISODate, toNum, toCents, toBoolean } from './index';
import { TRANSACTION_URL, TRANSACTION_URL_DEV, GET_ACCOUNT_URL, GET_ACCOUNT_DEV } from '../../../../constants/apiVariables';
import * as prepopulate from '../data/prepopulate.data';
import * as VN from '../constants/VendorNames';
import { getMetaOption } from '../constants/MetaOptions';

const removeEmpty = (obj) => {
    Object.keys(obj).forEach(key => {
      if (obj[key] && typeof obj[key] === 'object') removeEmpty(obj[key]);
      else if (obj[key] === undefined || obj[key] === "") delete obj[key];
    });
    return obj;
  };


function getField(fieldName, vendorName) {
    let field = get(prepopulate.default, [vendorName, fieldName], '');
    return field;
}

function isDeposit(pref) {
    if (pref === "PURCHASE") return true;
    return false;
}

function getAccountFormData(formData, options = {}) {
    const { vendorName } = options;
    let metaObj = getMetaOption(formData, options);

    let accountFormData = {
        "authentication": {
            "account_number": formData[ff.AUTH_CARD_NUMBER],
            "accountholder_billing_address": formData[ff.AUTH_BILLING_ADDRESS] || "",
            "accountholder_billing_zipcode": formData[ff.AUTH_ZIPCODE],
            "cvv": formData[ff.AUTH_CVV] || "",
            "expiration_date": getFormatedExpDate(formData[ff.AUTH_EXPIRATION_DATE]),
            // newly added default values
            "merchant_security_code": '12345',
            "authorization_code": '123456',
        },
        "amount": {
            "debit": vendorName !== VN.GREEN_DOT ? (isDeposit(formData[ff.TRANS_TYPE]) || true) : true,
            "transaction_currency": vendorName !== VN.GREEN_DOT ? (formData[ff.TRANS_CURRENCY] || "USD") : "USD",
            "transaction_value": toCents(formData[ff.TRANS_AMOUNT]) || "",
            "settlement_currency": "USD",
            "settlement_currency_conversion_rate": formData[ff.TRANS_CONVERSION_RATE] || "1",
            "settlement_value": formData[ff.TRANS_CONVERSION_RATE] ? toCents(formData[ff.TRANS_AMOUNT] * formData[ff.TRANS_CONVERSION_RATE]) : toCents(formData[ff.TRANS_AMOUNT]),
        },
        "meta": metaObj,
        //"timestamp": getISODate()
    }

    if (formData[ff.AUTH_PIN]) {
        accountFormData["authentication"]["pin"] = formData[ff.AUTH_PIN];
    }

    return accountFormData;
}


async function createTransaction(formData, options) {
    const { vendorName } = options;
    const accountFormData = getAccountFormData(formData, options);

    let transactionURL = TRANSACTION_URL;

    if (vendorName === VN.GREEN_DOT) {
        transactionURL = `${transactionURL}?network_id=greendot`;
    }
    try {
        const { data } = await axios.post(`${transactionURL}`, accountFormData);
        return data;
    } catch(error) {

    }
}

async function preAuthTransaction(options = {}) {

    const { transactionID, amount = 0, transaction_currency } = options;
    const reqBody = {
        amount: {
            ...(transaction_currency.length > 0 && { transaction_currency }),
            transaction_value: amount
        }
    };

    const { data } = await axios.put(`${TRANSACTION_URL}/${transactionID}`, reqBody);

    return data;
}

async function reverseTransaction(options = {}) {
    const { transactionID } = options;
    const reqBody = JSON.stringify({
        "reversal_reason": "CARD_ACCEPTOR|CUSTOMER_CANCELLATION"
    })

    const { data } = await axios({
        method: 'delete',
        url: `${TRANSACTION_URL}/${transactionID}`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: reqBody
    });
    return data;
}

async function getAccount(accountNumber) {
    let accountURL = GET_ACCOUNT_URL;

    const { data } = await axios.get(`${accountURL}/${accountNumber}`);
    return data;
}

export {
    getAccount,
    createTransaction,
    preAuthTransaction,
    reverseTransaction
}